import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AlertsComponent } from "./alerts/alerts.component";

const routes: Routes = [
	{
		path: "",
		component: AlertsComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class AlertsRoutingModule {}
